/**
 * @generated SignedSource<<c15360efb4c35045bc12c33d818006a4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GSNForContentSidebarEntryPoint$data = {
  readonly navPlatL1MenuData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly navPlatSidebarData: {
    readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps" | "Nav4Filters" | "Nav4Operations" | "Nav4Plans" | "Nav4Projects" | "Nav4Roadmaps_query" | "useGlobalShortcutsDataRelay" | "useNetworkSideNavUserData" | "useShowRoadmapsUpsell">;
  readonly " $fragmentType": "GSNForContentSidebarEntryPoint";
};
export type GSNForContentSidebarEntryPoint$key = {
  readonly " $data"?: GSNForContentSidebarEntryPoint$data;
  readonly " $fragmentSpreads": FragmentRefs<"GSNForContentSidebarEntryPoint">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "ownerAri",
  "variableName": "ownerAri"
},
v1 = [
  {
    "kind": "FragmentSpread",
    "name": "useNavSettingsService"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "currentURL"
    },
    {
      "kind": "RootArgument",
      "name": "fetchGlobalShortcutsAvailableProducts"
    },
    {
      "kind": "RootArgument",
      "name": "isRoadmapUpsellEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatMenuDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "navPlatSidebarDataEntityAri"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "name": "GSNForContentSidebarEntryPoint",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useNetworkSideNavUserData"
    },
    {
      "condition": "isRoadmapUpsellEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useShowRoadmapsUpsell"
        }
      ]
    },
    {
      "condition": "fetchGlobalShortcutsAvailableProducts",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useGlobalShortcutsDataRelay"
        }
      ]
    },
    {
      "alias": "navPlatL1MenuData",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "navPlatMenuDataEntityAri"
        },
        (v0/*: any*/)
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": (v1/*: any*/)
    },
    {
      "alias": "navPlatSidebarData",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "navPlatSidebarDataEntityAri"
        },
        (v0/*: any*/)
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": (v1/*: any*/)
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Apps"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Filters"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Operations"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Plans"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "currentURL",
          "variableName": "currentURL"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Nav4Projects"
    },
    {
      "kind": "FragmentSpread",
      "name": "Nav4Roadmaps_query"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "db5b58110710c6ab5fa756e1d45e0a7d";

export default node;
